export default function isFilledJSONValue(value) {
  if (!value) return false
  value = JSON.parse(value)

  for (let key in value) {
    if (value[key]) {
      return true
    }
  }

  return false
}
